  <div class="wrapper-header" [class.fixed]="offerService.selectedOffer?.offerEvents?.length">
    <a (click)="clickLogoToReload()">
      <img src="../../assets/images/logo-white-title.svg" width="76" alt="HUBX" class="logo _white-title" />
    </a>
    <div class="vendor-select" *ngIf="customers.length > 0 && vendorService.isImpersonatingRole" (click)="closeNav()">
      <app-dropdown [items]="customers" [fieldToShow]="'companyName'" [fieldToSave]="'bpCode'" [enableFilter]="true"
        [mobileHeaderTheme]="true" [(ngModel)]="selectedBpCode" (onSelect)="chooseVendor($event, true)">
      </app-dropdown>
    </div>
    <nav class="nav-wrap" [class.nav-open]="navToggle">
      <ul class="nav" (click)="closeNav()">
        <li>
        	<a class="nav-link" [routerLink]="['/vendor/user/profile']" routerLinkActive="active">
		        <i class="icon">
		          <img src="assets/images/icons/profile/profile.svg" width="24" height="24" alt="User Profile" />
		        </i>
		        <span>User Profile</span>
	        </a>
	    </li>
        <li>
        	<a class="nav-link" [routerLink]="['/vendor/user/mobile_notifications']" routerLinkActive="active">
	            <i class="icon">
	              <img src="assets/images/icons/profile/mobile-sms.svg" width="24" height="24"
	                alt="Mobile | SMS" />
	            </i>
	            <span>Mobile | SMS</span>
            </a>
        </li>
	    <li>
	    	<a class="nav-link" [routerLink]="['/vendor/user/offers']" routerLinkActive="active">
	    		<i class="icon">
					<img src="assets/images/icons/rebranding/offers-header.svg"  width="24" height="24"
	                alt="My Offers"/>
				</i>
				<span>My Offers</span>
				<ng-container *ngIf="vendorService.isImpersonatingRole; else sellerBadge">
					<span class="badge" *ngIf="offerService.bpUnseenEventCount > 0">
						{{offerService.bpUnseenEventCount}}
					</span>
				</ng-container>
				<ng-template #sellerBadge>
					<span class="badge" *ngIf="offerService.offersSummary?.unseenEventCount > 0">
						{{offerService.offersSummary?.unseenEventCount}}
					</span>
				</ng-template>
		    </a>
		</li>
      </ul>
    </nav>
    <div class="toggle-mobile-menu" [class.nav-open]="navToggle" (click)="toggleNav($event)">
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>